export const language = {
    storeLanguage: 'empty'
  };